import { DataTable } from "primereact/datatable";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { IModel, IWorkstreamMasterDocument } from "./RFP_Workstream_Master_Documents";
import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import { Tooltip } from "primereact/tooltip";
import { Dialog } from "primereact/dialog";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

interface IProps {
  setModel: (model: IModel) => void;
  toast: any;
  reload: boolean;
  permission: IPermissionProps;
  setReload: (is: boolean) => void;
}

export const Table = (props: IProps) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IWorkstreamMasterDocument>; loading: boolean });
  const [descriptionDialog, setDescriptionDialog] = useState<{ visible: boolean; description: string }>({ visible: false, description: "" });

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  let _roles: Array<number> = [];
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });
  const DateFormat = loginObj.date_Format;

  const descriptionDialogBox = (rowData: IWorkstreamMasterDocument) => {
    return rowData.doc_Description ? (
      <>
        <Tooltip target=".view-description" />
        <i
          className="pi pi-eye view-description cursor-pointer"
          data-pr-tooltip="View Description"
          data-pr-position="top"
          style={{ color: "var(--primary-color)", fontSize: "1.2rem" }}
          onClick={() =>
            setDescriptionDialog({
              visible: true,
              description: rowData.doc_Description ?? "",
            })
          }
        />
      </>
    ) : (
      "-"
    );
  };

  const leftToolbarTemplate = () => {
    return (
      <>
        <div className="my-2">
          <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
        </div>
      </>
    );
  };

  const loadMasterDocument = async () => {
    try {
      setTableData((prev: any) => ({ ...prev, loading: true }));
      const response = await Fetch("TenderWorkstream/GetMasterWorkstreamDocument", "GET", null, null, props.toast);
      if (response?.ok) {
        const data = await response.json();
        setTableData({ tableData: data, loading: false });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTableData((prev) => ({ ...prev, loading: false }));
    }
  };
  useEffect(() => {
    loadMasterDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.reload]);

  const openNew = () => {
    props.setModel({ singleData: {}, open: true });
  };

  const openEdit = (rowDatauser: IWorkstreamMasterDocument) => {
    props.setModel({ open: true, singleData: rowDatauser });
  };

  const actionBodyTemplate = (rowData: IWorkstreamMasterDocument) => {
    return (
      <div className="actions">
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
      </div>
    );
  };

  const downloadBody = (rowData: any) => {
    return rowData.doc_Path ? <Button icon="pi pi-download" className="p-button-rounded p-button-success p-button-text" tooltip="Download" onClick={() => downloadDoc(rowData.id)} /> : null;
  };

  const downloadDoc = async (documentID: number) => {
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/octet-stream",
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
      },
    };
    try {
      const response = await fetch(`${baseUrl}TenderWorkstream/WorkstreamMasterDocDownload?documentID=${documentID}`, params);

      if (response.status === 200) {
        const blob = await response.blob();

        const disposition = response.headers.get("content-disposition");
        let fileName = "WorkStream_Master_Document";

        if (disposition) {
          const match = disposition.match(/filename="?([^"]+)"?/);
          if (match?.[1]) {
            fileName = match[1];
          }
        }

        const href = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = href;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(href);
      }
    } catch {
      props.toast?.current?.show({ severity: "error", summary: "Error", detail: "Something went wrong", life: 3000 });
    }
  };

  const deleteBody = (rowData: any) => {
    return <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-text" tooltip="Delete" onClick={() => deleteDoc(rowData.id)} />;
  };

  const deleteDoc = (documentID: number) => {
    confirmDialog({
      header: "Delete Document",
      message: "Are you sure you want to delete this document?",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      acceptLabel: "Delete",
      rejectLabel: "Cancel",

      accept: async () => {
        const response = await Fetch(`TenderWorkstream/DeleteMasterWorkStreamDocument/${documentID}`, "DELETE", null, null, props.toast);

        if (response?.ok) {
          props.toast.current.show({ severity: "success", summary: "Success", detail: "Document Deleted Successfully", life: 3000 });
          props.setReload(!props.reload);
        } else {
          const msg = await response?.text();

          props.toast.current.show({ severity: "error", summary: "Error", detail: msg || "Delete failed", life: 3000 });
        }
      },
    });
  };

  return (
    <>
      <ConfirmDialog />
      <Toolbar left={leftToolbarTemplate} className="mb-3" />
      <DataTable value={tableData.tableData} style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} size="small" stripedRows showGridlines responsiveLayout="scroll" header="RFP Workstream Master Documents" loading={tableData.loading}>
        <Column field="title" header="Title" />
        <Column header="Description" body={descriptionDialogBox} />
        <Column field="workstream_Category" header="Workstream Category" />
        <Column header="Download" body={downloadBody} />
        <Column header="Added At" body={(rowData: any) => safeFormatDate(rowData.added_On, "dd/MM/yyyy", DateFormat)} style={{ minWidth: "120px" }} />
        <Column field="added_By" header="Added By" />
        <Column header="Update At" body={(rowData: any) => safeFormatDate(rowData.updated_On, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column field="updated_By" header="Update By" />
        <Column header="Actions" body={actionBodyTemplate} />
        {(_roles.includes(1) || _roles.includes(26) || _roles.includes(56)) && <Column header="Delete" body={deleteBody} />}
      </DataTable>
      {/* Decription Dialog */}
      <Dialog header="Description" visible={descriptionDialog.visible} modal style={{ width: "40vw" }} onHide={() => setDescriptionDialog({ visible: false, description: "" })}>
        <p style={{ whiteSpace: "pre-wrap" }}>{descriptionDialog.description}</p>
      </Dialog>
    </>
  );
};
